// extracted by mini-css-extract-plugin
export default {"dropdown":"AAuG44qahjKKlcrIKaLu","bluelabel2":"h3nQJz9XhM2x15AosZWu","bluelabel":"j7QUatuRYHYtvL1XznXa"};